import { SearchableDropdown } from './SearchableDropdown';

interface AttractionTypeDropdownProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function AttractionTypeDropdown({
  value,
  onChange,
  placeholder = 'Select Type',
  className,
}: AttractionTypeDropdownProps) {
  return (
    <SearchableDropdown
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search types..."
      className={className}
      endpoint="attraction-types"
      emptyText="No types found."
    />
  );
}
